import { Component, OnInit } from '@angular/core';

import { NotificationService } from '../Service/notification.service';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from '../Service/gurd-service.service';

import { OtherService } from '../Service/other.service';

import axios from 'src/app/Service/axios';

declare let $: any

@Component({

  selector: 'app-scholl-contractor',

  templateUrl: './scholl-contractor.component.html',

  styleUrls: ['./scholl-contractor.component.css']

})

export class SchollContractorComponent implements OnInit {

  acssess: any;

  list_Result: any = [];

  lst_Search: any = [];

  list_School: any = [];

  lst_Search2: any = [];

  list_Fleet: any = [];

  lst_Search3: any = [];

  lst_Search4: any = [];

  list_City: any[] = [];

  lstDistrict: any[] = [];

  lstLevel_List: any[] = [];

  lstSchoolType: any[] = [];

  lstPersonnelPosition: any[] = [];

  lstKeyPersonnel: any[] = [];

  lst_Headers = [
    { strName: '#' },
    { strName: 'عملیات' },
    { strName: 'نام' },
    { strName: 'شماره ثبت' },
    { strName: 'شناسه ملی' },
    { strName: 'تلفن' },
    { strName: 'موبایل' },
    { strName: 'شهر' },
    { strName: 'آدرس' },
  ];

  bEditMod: boolean = false;

  showFilter: boolean = false;

  showCustom_Map: boolean = false;

  showCustom_Map2: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strEDate: new FormControl(''),

  })

  mdl_Submit: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iContractor: new FormControl(''),

    strCity: new FormControl('', Validators.required),

    strName: new FormControl('', Validators.required),

    strNationalID: new FormControl('', Validators.required),

    strRegistrationNumber: new FormControl('', Validators.required),

    strTel: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    strAddress: new FormControl('', Validators.required),

    tiStatus: new FormControl(0),

    strEconomicCode: new FormControl(''),

    bPublicTransportation: new FormControl(false),

    bStudentTransportation: new FormControl(false),

    bCorporateTransportation: new FormControl(false),

    strCEOName: new FormControl('', Validators.required),

    fLat: new FormControl(0.0, Validators.required),

    fLon: new FormControl(0.0, Validators.required),

    strEmail: new FormControl('', [Validators.email]),

    strTransportationCoordinatorName: new FormControl(''),

    strTransportationCoordinatorMobile: new FormControl(''),

    bLicensedStudentTransportation: new FormControl(false),

    index: new FormControl(''),

  })

  mdl_Map: FormGroup = this.FormBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  })

  mdl_NewSchool: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iContractor: new FormControl(''),

    iContractor_Schools: new FormControl(''),

    strAddress: new FormControl('', Validators.required),

    tiStatus: new FormControl('', Validators.required),

    iFleetNumber: new FormControl('', Validators.required),

    iNumberStudents: new FormControl('', Validators.required),

    tiEducationDistrict: new FormControl('', Validators.required),

    tiGender: new FormControl('', Validators.required),

    tiEducationLevel: new FormControl('', Validators.required),

    strName: new FormControl('', Validators.required),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    index: new FormControl(''),


  })

  mdl_NewFleet: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iContractor: new FormControl(''),

    iCivilianFleets: new FormControl(''),

    iDrivers: new FormControl(''),

    iBuses: new FormControl('', Validators.required),

    iMinibus: new FormControl('', Validators.required),

    iVans: new FormControl('', Validators.required),

    iRides: new FormControl('', Validators.required),

    index: new FormControl(''),



  })

  mdl_Personnel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iContractor: new FormControl('', Validators.required),

    tiContractor_PersonnelPosition: new FormControl('', Validators.required),

    iContractor_KeyPersonnel: new FormControl(''),

    strFullName: new FormControl('', Validators.required),

    strID: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    index: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getContractors();

    this.getListCity();

    this.getDistrict();

    var data = window.localStorage.getItem("menu") as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

  }

  async getContractors() {

    this._otherService.Showspinner();

    let model = this._otherService.stringNumberToNumber(this.mdl_Search.value);

    let res = JSON.parse((await axios.post(`Contractor_List`, model)).data.toString());

    this._otherService.nonespinner()

    if (res.iResult == 0) return this._tooltip.showError(res.strError)

    this.list_Result = res;

    this.lst_Search = res;

  }

  filter_list(val: any) {

    this.list_Result = this.lst_Search.filter((el: any) => {

      return el.strName.startsWith(val.value)

        || el.strCityName.startsWith(val.value)

        || el.strRegistrationNumber.startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Result = this.lst_Search;

    }


  }

  filter_list2(val: any) {

    this.list_School = this.lst_Search2.filter((el: any) => {

      return el.strEducationLevel_strComment?.startsWith(val.value)

        || el.strEducationDistrict_strComment?.startsWith(val.value)

        || el.strGender?.startsWith(val.value)

        || el.strName?.startsWith(val.value)

        || el.strRegistrationNumber?.startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.list_School = this.lst_Search2;

    }


  }

  filter_list3(val: any) {

    // this.list_School = this.lst_Search2.filter((el: any) => {

    //   return el.strEducationLevel_strComment?.startsWith(val.value)

    //     || el.strEducationDistrict_strComment?.startsWith(val.value)

    //     || el.strGender?.startsWith(val.value)

    //     || el.strName?.startsWith(val.value)

    //     || el.strRegistrationNumber?.startsWith(val.value)

    // });

    // if (val.value.trim() == '') {

    //   this.list_School = this.lst_Search2;

    // }


  }

  filter_list4(val: any) {

    this.lstKeyPersonnel = this.lst_Search4.filter((el: any) => {

      return el.strFullName?.startsWith(val.value) || el.strContractor_PersonnelPosition_strComment?.startsWith(val.value)

    });

    if (val.value.trim() == '') {

      this.lstKeyPersonnel = this.lst_Search4;

    }


  }

  openModal(item: any = {}, index: number = 0) {

    if (!item?.iContractor) {

      this.bEditMod = false;

      this.mdl_Submit.patchValue({

        iContractor: '',

        strCity: '',

        strName: '',

        strNationalID: '',

        strRegistrationNumber: '',

        strTel: '',

        strMobile: '',

        strAddress: '',

        tiStatus: '-1',

        strEconomicCode: '',

        bPublicTransportation: false,

        bStudentTransportation: false,

        bCorporateTransportation: false,

        strCEOName: '',

        fLat: 0,

        fLon: 0,

        strEmail: '',

        strTransportationCoordinatorName: '',

        strTransportationCoordinatorMobile: '',

        bLicensedStudentTransportation: false,

      })

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#AddOrEdit_Modal").modal('show')

    }

    else {

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      Object.keys(item).forEach((key) => {

        this.mdl_Submit.get(key)?.setValue(item[key]);

      })

      this.mdl_Submit.get('index')?.setValue(index)

      this.bEditMod = true;

      $("#AddOrEdit_Modal").modal('show');

    }

  }

  getListCity = async () => {

    this._otherService.Showspinner()

    let res = JSON.parse((await axios.post(`City_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner()

    this.list_City = res;


  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  async submit_Request() {

    const emailControl = this.mdl_Submit.get('strEmail');

    if (emailControl && emailControl.invalid && emailControl.touched) {

      if (emailControl.hasError('email')) {

        this._tooltip.showError('فرمت ایمیل نامعتبر است!');

        return;

      }

    }

    if (this.mdl_Submit.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید!')

    if (!this.bEditMod) {

      this._otherService.Showspinner();

      let model = this._otherService.stringNumberToNumber(this.mdl_Submit.value);

      let res = JSON.parse((await axios.post(`Contractor_Save`, model)).data.toString());

      this._otherService.nonespinner()

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('با موفقیت ثبت شد.');

      this.list_Result.push(res[0]);

      this.lst_Search = this.list_Result;

      $("#AddOrEdit_Modal").modal('hide')

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let model = this._otherService.stringNumberToNumber(this.mdl_Submit.value);

              let res = JSON.parse((await axios.post(`Contractor_Update`, model)).data.toString())[0];

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.list_Result[this.mdl_Submit.get('index')?.value] = res;

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              this.bEditMod = false;

              $(`#AddOrEdit_Modal`).modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  async submit_School() {

    if (this.mdl_NewSchool.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید!')

    if (!this.bEditMod) {

      this._otherService.Showspinner();

      let model = this._otherService.stringNumberToNumber(this.mdl_NewSchool.value);

      let res = JSON.parse((await axios.post(`Contractor_Schools_Save`, model)).data.toString());

      this._otherService.nonespinner()

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('با موفقیت ثبت شد.');

      this.list_School.push(res[0]);

      this.lst_Search2 = this.list_School;

      $("#SchoolAddOrEdit_Modal").modal('hide');

      $("#schools_Modal").modal('show');

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let model = this._otherService.stringNumberToNumber(this.mdl_NewSchool.value);

              let res = JSON.parse((await axios.post(`Contractor_Schools_Edit`, model)).data.toString())[0];

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.list_School[this.mdl_NewSchool.get('index')?.value] = res;

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              this.bEditMod = false;

              $("#SchoolAddOrEdit_Modal").modal('hide');

              $("#schools_Modal").modal('show');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  removeItem(item, index) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner()

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iContractor: item.iContractor
            }

            let res = JSON.parse((await axios.post(`Contractor_Delete`, this._otherService.stringNumberToNumber(model))).data.toString());

            this._otherService.nonespinner()

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            else {

              this.list_Result.splice(index, 1);

              this._tooltip.showSuccess(' با موفقیت حذف شد');

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });
  }

  show_Map() {

    let mdl_Request = this.mdl_Submit.value;

    if (mdl_Request.strCity == '') return this._tooltip.showError('ابتدا شهر خور را انتخاب کنید!')

    let cityName = this.returnStrValue('strCity', mdl_Request.strCity, this.list_City, 'strCityName');

    let address = !mdl_Request.strAddress.startsWith(cityName) ? cityName + '، ' + mdl_Request.strAddress : mdl_Request.strAddress;

    this.mdl_Map.patchValue({

      strAddress: address == cityName + '، ' ? '' : address,

      fLon: mdl_Request.fLon == '' ? this.get_latLong(mdl_Request.strCity, 'fLon') : mdl_Request.fLon,

      fLat: mdl_Request.fLat == '' ? this.get_latLong(mdl_Request.strCity, 'fLat') : mdl_Request.fLat,

      strSource: 'strAddress'

    })

    this.showCustom_Map = true;

  }

  show_Map2() {

    let mdl_Request = this.mdl_NewSchool.value;

    // if (mdl_Request.strCity == '') return this._tooltip.showError('ابتدا شهر خور را انتخاب کنید!')

    // let cityName = this.returnStrValue('strCity', mdl_Request.strCity, this.list_City, 'strCityName');

    // let address = !mdl_Request.strAddress.startsWith(cityName) ? cityName + '، ' + mdl_Request.strAddress : mdl_Request.strAddress;

    this.mdl_Map.patchValue({

      strAddress: mdl_Request.strAddress,

      fLon: 0,

      fLat: 0,

      strSource: 'strAddress'

    })

    this.showCustom_Map2 = true;

  }

  get_latLong(strCity: number | string, target: 'fLon' | 'fLat'): number {

    return this.list_City.filter((el: any) => { return el.strCity == strCity })[0][target];

  }

  submitMap(event: any) {

    this.showCustom_Map = false;

    this.showCustom_Map2 = false;

    if (event.strText != '') {

      this.mdl_Submit.patchValue({

        strAddress: event.strText,

        fLon: event.longitude,

        fLat: event.latitude,

      })

      this.mdl_NewSchool.patchValue({

        strAddress: event.strText,

        fLon: event.longitude,

        fLat: event.latitude,

      })

    }

    else {

      this.mdl_Submit.patchValue({

        strAddress: '',

        fLon: '',

        fLat: '',

      })

      this.mdl_NewSchool.patchValue({

        strAddress: '',

        fLon: '',

        fLat: '',

      })

    }

  }

  async getDistrict() {

    var model = {

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    let res = JSON.parse((await axios.post(`EducationDistrict_List`, model)).data.toString());

    this.lstDistrict = res;

    // -----------------------------------------------------------

    let res2 = JSON.parse((await axios.post(`EducationLevel_List`, model)).data.toString());

    this.lstLevel_List = res2;

    // -----------------------------------------------------------

    let res3 = JSON.parse((await axios.post(`SchoolType_List`, model)).data.toString());

    this.lstSchoolType = res3;

    // -----------------------------------------------------------

    let res4 = JSON.parse((await axios.post(`Contractor_PersonnelPosition_List`, model)).data.toString());

    this.lstPersonnelPosition = res4;

    // console.log(res4)

  }

  async openSchools(item) {

    this._otherService.Showspinner();

    let model = this._otherService.stringNumberToNumber({ ...this.mdl_Search.value, iContractor: item.iContractor });

    let res = JSON.parse((await axios.post(`Contractor_Schools_List`, model)).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.list_School = res;

    this.lst_Search2 = res;

    this.mdl_NewSchool.get('iContractor')?.setValue(item.iContractor);

    $("#schools_Modal").modal('show')

  }

  async openFleet(item) {

    this._otherService.Showspinner();

    let model = this._otherService.stringNumberToNumber({ ...this.mdl_Search.value, iContractor: item.iContractor });

    let res = JSON.parse((await axios.post(`Contractor_Fleet_Info`, model)).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.mdl_NewFleet.get('iContractor')?.setValue(item.iContractor);

    this.addFleet(res.length ? res[0] : {})

    console.log(res[0]);

    // this.list_Fleet = res;

    // this.lst_Search3 = res;

    // $("#fleets_Modal").modal('show');

  }

  async openPersonnel(item) {

    this._otherService.Showspinner();

    let model = this._otherService.stringNumberToNumber({ ...this.mdl_Search.value, iContractor: item.iContractor });

    let res = JSON.parse((await axios.post(`Contractor_KeyPersonnel_List`, model)).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstKeyPersonnel = res;

    this.lst_Search3 = res;

    this.mdl_Personnel.get('iContractor')?.setValue(item.iContractor);

    $("#personnel_Modal").modal('show');

  }

  addSchool(item: any = {}, index: number = 0) {

    if (!item?.iContractor_Schools) {

      this.bEditMod = false;

      this.mdl_NewSchool.patchValue({

        strAddress: '',

        tiStatus: '',

        iFleetNumber: '',

        iNumberStudents: '',

        tiEducationDistrict: '',

        tiGender: '',

        tiEducationLevel: '',

        strName: '',

        fLon: '',

        fLat: '',

        index: '',

      })

      $("#schools_Modal").modal('hide')

      $("#SchoolAddOrEdit_Modal").modal('show')

    }

    else {

      Object.keys(item).forEach((key) => {

        this.mdl_NewSchool.get(key)?.setValue(item[key]);

      })

      this.mdl_NewSchool.get('index')?.setValue(index)

      this.bEditMod = true;

      $("#schools_Modal").modal('hide')

      $("#SchoolAddOrEdit_Modal").modal('show')

    }

  }

  addFleet(item: any = {}, index: number = 0) {

    if (!item?.iCivilianFleets?.toString()) {

      this.bEditMod = false;

      this.mdl_NewFleet.patchValue({

        iCivilianFleets: '',

        iDrivers: '0',

        iBuses: '',

        iMinibus: '',

        iVans: '',

        iRides: '',

        index: '',

      })

      $("#fleets_Modal").modal('hide')

      $("#fleetAddOrEdit_Modal").modal('show')

    }

    else {

      Object.keys(item).forEach((key) => {

        this.mdl_NewFleet.get(key)?.setValue(item[key]);

      })

      this.mdl_NewFleet.get('index')?.setValue(index)

      this.bEditMod = true;

      $("#fleets_Modal").modal('hide')

      $("#fleetAddOrEdit_Modal").modal('show')

    }

  }

  addPersonnel(item: any = {}, index: number = 0) {

    if (!item?.iContractor_KeyPersonnel) {

      this.bEditMod = false;

      this.mdl_Personnel.patchValue({

        iContractor_KeyPersonnel: '',

        tiContractor_PersonnelPosition: '',

        strFullName: '',

        strID: '',

        strMobile: '',

      })

      $("#personnel_Modal").modal('hide')

      $("#personnelAddOrEdit_Modal").modal('show')

    }

    else {

      Object.keys(item).forEach((key) => {

        this.mdl_Personnel.get(key)?.setValue(item[key]);

      })

      this.mdl_Personnel.get('index')?.setValue(index)

      this.bEditMod = true;

      $("#personnel_Modal").modal('hide')

      $("#personnelAddOrEdit_Modal").modal('show')

    }

  }

  removeSchool(item, index) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner()

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iContractor_Schools: item.iContractor_Schools
            }

            let res = JSON.parse((await axios.post(`Contractor_Schools_Delete`, this._otherService.stringNumberToNumber(model))).data.toString());

            this._otherService.nonespinner()

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            else {

              this.list_School.splice(index, 1);

              this._tooltip.showSuccess(' با موفقیت حذف شد');

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });
  }

  async submit_Fleet() {

    if (this.mdl_NewFleet.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید!')

    if (!this.bEditMod) {

      this._otherService.Showspinner();

      let model = this._otherService.stringNumberToNumber(this.mdl_NewFleet.value);

      let res = JSON.parse((await axios.post(`Contractor_Fleet_Save`, model)).data.toString());

      this._otherService.nonespinner()

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('با موفقیت ثبت شد.');

      this.list_Fleet.push(res[0]);

      this.lst_Search2 = this.list_Fleet;

      $("#fleetAddOrEdit_Modal").modal('hide');

      $("#fleets_Modal").modal('show');

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let model = this._otherService.stringNumberToNumber(this.mdl_NewFleet.value);

              let res = JSON.parse((await axios.post(`Contractor_Fleet_Save`, model)).data.toString())[0];

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.list_Fleet[this.mdl_NewFleet.get('index')?.value] = res;

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              this.bEditMod = false;

              $("#fleetAddOrEdit_Modal").modal('hide');

              $("#fleets_Modal").modal('show');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  async submit_Personnel() {

    if (this.mdl_Personnel.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید!')

    if (!this.bEditMod) {

      this._otherService.Showspinner();

      let model = this._otherService.stringNumberToNumber(this.mdl_Personnel.value);

      let res = JSON.parse((await axios.post(`Contractor_KeyPersonnel_Save`, model)).data.toString());

      this._otherService.nonespinner()

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('با موفقیت ثبت شد.');

      this.lstKeyPersonnel.push(res[0]);

      this.lst_Search4 = this.lstKeyPersonnel;

      $("#personnelAddOrEdit_Modal").modal('hide');

      $("#personnel_Modal").modal('show');

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let model = this._otherService.stringNumberToNumber(this.mdl_Personnel.value);

              let res = JSON.parse((await axios.post(`Contractor_KeyPersonnel_Edit`, model)).data.toString())[0];

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lstKeyPersonnel[this.mdl_Personnel.get('index')?.value] = res;

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              this.bEditMod = false;

              $("#personnelAddOrEdit_Modal").modal('hide');

              $("#personnel_Modal").modal('show');


            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  removePersonnel(item, index) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner()

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iContractor_KeyPersonnel: item.iContractor_KeyPersonnel
            }

            let res = JSON.parse((await axios.post(`Contractor_KeyPersonnel_Delete`, this._otherService.stringNumberToNumber(model))).data.toString());

            this._otherService.nonespinner()

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            else {

              this.lstKeyPersonnel.splice(index, 1);

              this._tooltip.showSuccess(' با موفقیت حذف شد');

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });
  }

  accessibility(...array: string[]): boolean {

    let result = false;

    for (let i = 0; i < array.length; i++) {

      if (this.acssess[array[i]] == true && !result) {

        result = true;

        break;

      }

    }

    return result;

  }

}
